export default "__VITE_ASSET__ZsU$DD7S__"